var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"width":"100%","height":"500px"},attrs:{"id":"map"}}),_c('BaseFormLoading',{attrs:{"loading":_vm.loading.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }